import React from 'react';
import { Popover, Button } from 'react-bootstrap';

const TaskPriorityPopover = ({ task, onUpdate, ...props }) => {
    const handlePriorityChange = (level) => {
        if (onUpdate) {
            onUpdate({ priority: level });
        }
        document.body.click(); // Close popover
    };

    return (
        <Popover id={`popover-priority-${task.id}`} {...props}>
            <Popover.Header as="h3">Priority</Popover.Header>
            <Popover.Body>
                <div className="d-flex flex-column gap-1">
                    <Button variant="light" size="sm" className="text-start text-danger fw-bold" onClick={() => handlePriorityChange(3)}>
                        High
                    </Button>
                    <Button variant="light" size="sm" className="text-start text-warning fw-bold" onClick={() => handlePriorityChange(2)}>
                        Medium
                    </Button>
                    <Button variant="light" size="sm" className="text-start text-secondary" onClick={() => handlePriorityChange(1)}>
                        Low
                    </Button>
                    <Button variant="light" size="sm" className="text-start text-muted" onClick={() => handlePriorityChange(0)}>
                        None
                    </Button>
                </div>
            </Popover.Body>
        </Popover>
    );
};

export default TaskPriorityPopover;
